export type FilmType = "movie" | "tv" | "variety";

export interface Film {
  id: string;
  title: string;
  type: FilmType;
  cover: string;
  year: number;
  region: string;
  popularity: number;
  rating: number;
  director: string;
  cast: string[];
  synopsis: string;
  tags: string[];
}

export const films: Film[] = [
  {
    id: "f1",
    title: "长夜将明",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20key%20art%20of%20a%20midnight%20city%20mystery%20scene%20with%20a%20lone%20figure%20silhouette%20under%20rain%2C%20dramatic%20deep%20navy%20blue%20shadows%20and%20warm%20orange%20rim%20light%2C%20moody%20atmospheric%20fog%2C%20elegant%20minimal%20composition%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f1&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    popularity: 96,
    rating: 8.6,
    director: "郑清和",
    cast: ["a1", "a2", "a7"],
    synopsis:
      "一桩十年前的悬案重新浮出水面，刑警与记者在漫长的黑夜里并肩追凶，真相往往藏在最不愿被承认的角落。",
    tags: ["悬疑", "犯罪", "剧情"],
  },
  {
    id: "f2",
    title: "雾港迷航",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20key%20art%20of%20a%20foggy%20harbour%20with%20an%20old%20cargo%20ship%20drifting%20at%20dawn%2C%20deep%20blue%20mist%20and%20faint%20orange%20lantern%20glow%2C%20tense%20thriller%20mood%2C%20moody%20atmospheric%20fog%2C%20elegant%20minimal%20composition%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f2&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    popularity: 88,
    rating: 7.9,
    director: "陈岩",
    cast: ["a4", "a3", "a8"],
    synopsis:
      "一艘深夜失踪的货轮，把三个素不相识的人卷入同一场迷雾。港口的水面下，比风暴更危险的是人心。",
    tags: ["悬疑", "惊悚", "剧情"],
  },
  {
    id: "f3",
    title: "山与海之间",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20a%20coastal%20mountain%20town%20at%20dusk%2C%20two%20figures%20standing%20apart%20on%20a%20cliff%20path%2C%20deep%20navy%20sky%20with%20warm%20orange%20sunset%20horizon%2C%20emotional%20urban%20drama%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f3&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    popularity: 92,
    rating: 8.2,
    director: "林牧",
    cast: ["a2", "a8", "a7"],
    synopsis:
      "离家多年的建筑师回到海边小城，与旧友重逢。山海之间，那些没说出口的话，终要在潮起潮落里被听见。",
    tags: ["都市", "情感", "家庭"],
  },
  {
    id: "f4",
    title: "都市迷情",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20neon%20city%20streets%20reflected%20in%20wet%20asphalt%20at%20night%2C%20a%20couple%20walking%20under%20warm%20orange%20shop%20signs%2C%20deep%20navy%20blue%20tones%2C%20romantic%20urban%20drama%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f4&orientation=portrait",
    year: 2023,
    region: "中国香港",
    popularity: 76,
    rating: 7.4,
    director: "麦嘉伦",
    cast: ["a3", "a9"],
    synopsis:
      "在寸土寸金的都市里，两个被生活推着走的人，在无数个擦肩而过的夜里，慢慢学会了停下来。",
    tags: ["都市", "爱情"],
  },
  {
    id: "f5",
    title: "笑傲江湖会",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20key%20art%20of%20a%20bright%20stage%20with%20warm%20orange%20spotlights%20and%20deep%20navy%20blue%20backdrop%2C%20playful%20energetic%20comedy%20competition%20mood%2C%20confetti%20and%20light%20beams%2C%20high%20detail%2C%20cohesive%20vibrant%20color%20grading&width=480&height=720&seq=film-f5&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    popularity: 90,
    rating: 8.0,
    director: "沈立",
    cast: ["a7", "a1"],
    synopsis:
      "每期邀请不同领域的嘉宾同台竞技，用即兴与默契碰撞出笑点，也给观众带来治愈与共鸣。",
    tags: ["喜剧", "竞技", "真人秀"],
  },
  {
    id: "f6",
    title: "星轨之外",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20key%20art%20of%20an%20astronaut%20floating%20before%20a%20huge%20planet%20ring%2C%20deep%20navy%20blue%20space%20with%20warm%20orange%20engine%20glow%2C%20epic%20adventure%20mood%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f6&orientation=portrait",
    year: 2026,
    region: "美国",
    popularity: 94,
    rating: 8.4,
    director: "安德鲁·诺兰",
    cast: ["a10", "a2"],
    synopsis:
      "当人类第一次驶向星轨之外，一段被抹去的航行日志成为唯一线索。宇宙的尽头，也许正是回家的方向。",
    tags: ["科幻", "冒险"],
  },
  {
    id: "f7",
    title: "回到1999",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20poster%20key%20art%20of%20a%201990s%20Chinese%20town%20street%20at%20sunset%20with%20old%20bicycles%20and%20posters%2C%20warm%20orange%20light%20and%20deep%20navy%20blue%20shadows%2C%20youth%20coming%20of%20age%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f7&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    popularity: 82,
    rating: 7.8,
    director: "周牧",
    cast: ["a1", "a7", "a8"],
    synopsis:
      "一次意外让少年回到了世纪之交。他试图改写那些遗憾，却发现真正想留住的，是那段再也回不去的时光。",
    tags: ["年代", "青春", "奇幻"],
  },
  {
    id: "f8",
    title: "刃",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20key%20art%20of%20a%20sharp%20blade%20catching%20orange%20light%20against%20a%20dark%20navy%20alley%2C%20rain%20and%20steam%2C%20intense%20crime%20thriller%20mood%2C%20dynamic%20dramatic%20composition%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f8&orientation=portrait",
    year: 2024,
    region: "韩国",
    popularity: 85,
    rating: 8.1,
    director: "朴正焕",
    cast: ["a6", "a4"],
    synopsis:
      "退役的拳手被卷入地下世界，为了守护仅剩的亲人，他必须重新握紧那把生锈的刃。",
    tags: ["动作", "犯罪", "剧情"],
  },
  {
    id: "f9",
    title: "樱花落时",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20poster%20key%20art%20of%20falling%20cherry%20blossoms%20over%20a%20quiet%20Japanese%20lantern%20street%2C%20soft%20warm%20orange%20paper%20light%2C%20deep%20navy%20blue%20evening%20sky%2C%20gentle%20melancholic%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f9&orientation=portrait",
    year: 2023,
    region: "日本",
    popularity: 74,
    rating: 7.6,
    director: "佐藤健一",
    cast: ["a5", "a6"],
    synopsis:
      "在樱花凋落的小镇，一位图书管理员与旅人相遇又告别。有些缘分，只为陪你走过一个季节。",
    tags: ["爱情", "剧情", "治愈"],
  },
  {
    id: "f10",
    title: "风声再起",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20spy%20thriller%20movie%20poster%20key%20art%20of%20a%20figure%20in%20a%20long%20coat%20standing%20in%20a%20dim%20corridor%2C%20shattered%20orange%20candle%20light%20and%20deep%20navy%20blue%20shadow%2C%20tense%20mysterious%20mood%2C%20elegant%20minimal%20composition%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f10&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    popularity: 98,
    rating: 8.8,
    director: "郑清和",
    cast: ["a4", "a1", "a9"],
    synopsis:
      "旧信件的出现让尘封的谍报网络再次活跃。在风声最紧的时刻，谁在传递真相，谁又在传递谎言。",
    tags: ["谍战", "悬疑", "剧情"],
  },
  {
    id: "f11",
    title: "向往的厨房",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20cooking%20variety%20show%20poster%20key%20art%20of%20a%20warm%20rustic%20kitchen%20counter%20with%20fresh%20ingredients%2C%20cozy%20orange%20candlelight%20and%20deep%20navy%20blue%20evening%20tones%2C%20relaxed%20lifestyle%20mood%2C%20high%20detail%2C%20cohesive%20warm%20color%20grading&width=480&height=720&seq=film-f11&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    popularity: 70,
    rating: 7.3,
    director: "许安然",
    cast: ["a8", "a3"],
    synopsis:
      "远离城市的厨房里，几位好友用一顿顿家常菜，交换各自的故事，也慢慢找回生活的节奏。",
    tags: ["美食", "生活", "真人秀"],
  },
  {
    id: "f12",
    title: "深海回声",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20key%20art%20of%20a%20submarine%20window%20looking%20into%20deep%20dark%20ocean%2C%20faint%20orange%20bioluminescent%20light%20in%20deep%20navy%20blue%20water%2C%20mysterious%20suspenseful%20mood%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f12&orientation=portrait",
    year: 2024,
    region: "英国",
    popularity: 79,
    rating: 8.0,
    director: "詹姆斯·霍华德",
    cast: ["a10", "a5"],
    synopsis:
      "深潜队在马里亚纳海沟收到一段来自海底的回声。那声音无法被解释，却与人类的历史惊人相似。",
    tags: ["科幻", "悬疑"],
  },
  {
    id: "f13",
    title: "少年游",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20poster%20key%20art%20of%20a%20young%20swordsman%20on%20a%20misty%20mountain%20pass%2C%20deep%20navy%20blue%20pines%20with%20warm%20orange%20torch%20glow%2C%20heroic%20ancient%20adventure%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f13&orientation=portrait",
    year: 2026,
    region: "中国大陆",
    popularity: 89,
    rating: 8.3,
    director: "林牧",
    cast: ["a7", "a2"],
    synopsis:
      "少年负剑出山，只为查明师门旧案。江湖路远，他在一次次选择中，长成了自己曾仰望的样子。",
    tags: ["古装", "武侠"],
  },
  {
    id: "f14",
    title: "午夜书店",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20poster%20key%20art%20of%20a%20tiny%20old%20bookstore%20glowing%20warm%20orange%20at%20midnight%2C%20deep%20navy%20blue%20rainy%20street%2C%20cozy%20magical%20healing%20mood%2C%20soft%20film%20grain%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f14&orientation=portrait",
    year: 2025,
    region: "日本",
    popularity: 78,
    rating: 7.9,
    director: "佐藤健一",
    cast: ["a5", "a9"],
    synopsis:
      "只在午夜营业的书店里，每位客人都能借到一本改写自己故事的书。但代价，是忘记一段记忆。",
    tags: ["奇幻", "治愈", "剧情"],
  },
  {
    id: "f15",
    title: "巅峰对决",
    type: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20variety%20poster%20key%20art%20of%20a%20dramatic%20arena%20with%20warm%20orange%20beams%20and%20deep%20navy%20blue%20stands%2C%20intense%20competition%20momentum%20mood%2C%20dynamic%20diagonal%20composition%2C%20high%20detail%2C%20cohesive%20cinematic%20color%20grading&width=480&height=720&seq=film-f15&orientation=portrait",
    year: 2026,
    region: "中国大陆",
    popularity: 84,
    rating: 7.7,
    director: "沈立",
    cast: ["a6", "a4", "a1"],
    synopsis:
      "来自各地的挑战者围绕同一项极限任务展开对决，汗水与默契之外，更考验的是不服输的心。",
    tags: ["竞技", "真人秀"],
  },
];